import { makeStyles } from 'tss-react/mui'

/** Matches the `lg` breakpoint, for when the chat dock — not the window —
 *  is what made the page narrow. */
const NARROW_CONTAINER = '@container labra-chat-main (max-width: 1200px)'

export const useStyles = makeStyles()(theme => ({
  root: {
    boxSizing: 'border-box',
    width: '100%',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    gap: 24,
    alignItems: 'stretch',
    padding: 24,
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      overflowY: 'auto',
    },
    [NARROW_CONTAINER]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      overflowY: 'auto',
    },
  },
  leftColumn: {
    flex: '1 1 0',
    minWidth: 0,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    '& > :not(:last-child)': {
      flexShrink: 0,
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      flex: 'none',
    },
    [NARROW_CONTAINER]: {
      width: '100%',
      flex: 'none',
    },
  },
  rightColumn: {
    width: 444,
    flexShrink: 0,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    // Cap the panel to the row (table) height and split it across the boxes so
    // the page itself never scrolls — each box scrolls internally instead.
    overflow: 'hidden',
    '& > *': {
      flex: '1 1 0',
      minHeight: 0,
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      overflow: 'visible',
      '& > *': {
        flex: 'none',
      },
    },
    [NARROW_CONTAINER]: {
      width: '100%',
      overflow: 'visible',
      '& > *': {
        flex: 'none',
      },
    },
  },
}))
